import RadioCardListPage from "@components/RadioCardListPage"
import { isHomeDesignFlow } from "@helpers/localStorage"

const OPTIONS = [
  { emoji: "💪", key: "confidence" },
  { emoji: "🎨", key: "creativity" },
  { emoji: "🎉", key: "playfulness" },
  { emoji: "💎", key: "sophistication" },
  { emoji: "✨", key: "authenticity" },
  { emoji: "🌍", key: "adventure" },
]

const HOME_OPTIONS = [
  { emoji: "🤗", key: "cozyWarm" },
  { emoji: "🔥", key: "boldDramatic" },
  { emoji: "🧘", key: "cleanMinimal" },
  { emoji: "🌿", key: "naturalOrganic" },
  { emoji: "💎", key: "sophisticatedRefined" },
  { emoji: "🎨", key: "playfulEclectic" },
]

export default function PersonalityPage() {
  if (isHomeDesignFlow()) {
    return (
      <RadioCardListPage
        translationKey="personalityHomeDesign"
        options={HOME_OPTIONS}
      />
    )
  }
  return <RadioCardListPage translationKey="personality" options={OPTIONS} />
}
